export const CONTEXT_SEARCH = 'iglu:com.gladly/context_search/jsonschema/1-0-0';

export const getSearchContext = searchResult => ({
  schema: CONTEXT_SEARCH,
  data: {
    id: searchResult.id,
    searchTerm: searchResult.query.text,
  },
});



// WEBPACK FOOTER //
// ./src/scripts/lib/analytics/snowplow/contexts/search_context.js